module.exports = __webpack_public_path__ + "img/LogoFlaxeo-RVB-Noir+Turquoise-Baseline-F.50b2bc9a.webp";